module.exports = __webpack_public_path__ + "f56a358742db1d15fc06934278e59703.svg";